import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { heroSubtitleVariant } from '../../animations/animations';

const terminalLines = [
  { text: '$ uname -a', type: 'command' },
  { text: 'Linux amlogic-fleet 5.15.0 #1 SMP PREEMPT armv7l GNU/Linux', type: 'output' },
  { text: '$ ./apex_updater --verify', type: 'command' },
  { text: '[✓] RSA-2048 signature verified', type: 'success' },
  { text: '[✓] AES-256-CBC decryption complete', type: 'success' },
  { text: '[✓] SHA-256 downgrade check passed', type: 'success' },
  { text: '[✓] Disk space OK - proceeding with install', type: 'success' },
  { text: '$ uptime', type: 'command' },
  { text: ' 100% - 100+ days continuous operation', type: 'output' },
];

const LINE_INTERVAL = 450;
const START_DELAY = 3200;

const TerminalBlock = () => {
  const [visibleCount, setVisibleCount] = useState(0);

  useEffect(() => {
    const timers = [];
    const startTimeout = setTimeout(() => {
      terminalLines.forEach((_, idx) => {
        const t = setTimeout(() => {
          setVisibleCount(idx + 1);
        }, idx * LINE_INTERVAL);
        timers.push(t);
      });
    }, START_DELAY);
    timers.push(startTimeout);
    return () => timers.forEach(clearTimeout);
  }, []);

  const renderLine = (line, idx) => {
    const isLastVisible = idx === visibleCount - 1 && visibleCount < terminalLines.length;
    if (line.type === 'command') {
      return (
        <div key={idx} className="flex items-center">
          <span style={{ color: '#a5b4fc' }}>$ </span>
          <span style={{ color: '#e5e5e5' }}>{line.text.slice(2)}</span>
          {isLastVisible && <span className="terminal-cursor" />}
        </div>
      );
    }
    if (line.type === 'success') {
      return (
        <div key={idx} style={{ color: '#22c55e' }}>
          {line.text}
          {isLastVisible && <span className="terminal-cursor" />}
        </div>
      );
    }
    return (
      <div key={idx} style={{ color: '#9ca3af' }}>
        {line.text}
        {isLastVisible && <span className="terminal-cursor" />}
      </div>
    );
  };

  return (
    <motion.div
      variants={heroSubtitleVariant(4)}
      initial="initial"
      animate="animate"
      className="w-full max-w-2xl mx-auto mb-8 rounded-xl overflow-hidden"
      style={{
        border: '1px solid rgba(99,102,241,0.3)',
        boxShadow: '0 0 25px rgba(99,102,241,0.12)',
      }}
    >
      <div
        className="flex items-center gap-2 px-4 py-2.5"
        style={{ background: '#161b22' }}
      >
        <span className="w-3 h-3 rounded-full" style={{ background: '#ff5f57' }} />
        <span className="w-3 h-3 rounded-full" style={{ background: '#febc2e' }} />
        <span className="w-3 h-3 rounded-full" style={{ background: '#28c840' }} />
        <span
          className="text-xs ml-2"
          style={{ color: '#6b7280', fontFamily: "'JetBrains Mono', 'Fira Code', monospace" }}
        >
          amlogic-fleet - bash
        </span>
      </div>
      <div
        className="p-4 text-sm leading-relaxed min-h-[200px]"
        style={{ background: '#0d1117', fontFamily: "'JetBrains Mono', 'Fira Code', monospace" }}
      >
        {terminalLines.slice(0, visibleCount).map((line, idx) => renderLine(line, idx))}
        {visibleCount === 0 && <span className="terminal-cursor" />}
      </div>
    </motion.div>
  );
};

export default TerminalBlock;
